export default "__VITE_ASSET__3yL9l7wf__"